export const FLAG_GETTING_MECHANICS = 'FLAG_GETTING_MECHANICS';
export const GET_MECHANICS = 'GET_MECHANICS';
export const CLEAR_MECHANICS = 'CLEAR_MECHANICS';
export const FLAG_MECHANIC_ACTIVITY = 'FLAG_MECHANIC_ACTIVITY';
export const GET_MECHANIC = 'GET_MECHANIC';
export const CLEAR_MECHANIC = 'CLEAR_MECHANIC';
